import { Lock, LockOpen, LockOpenOutlined, LockOpenRounded, LockOutlined, Visibility, VisibilityOff } from "@mui/icons-material";
import { Avatar, Box, Card, FormControl, FormHelperText, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput, Slide, Stack, styled, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AnimateButton from "../../../../components/@extended/AnimateButton";
import MDBox from "../../../../components/MDBox";
import MDButton from "../../../../components/MDButton";
import MDTypography from "../../../../components/MDTypography";
import { clearUpdateUserFieldErr, tryResetUpdateUserFormErr, tryUpdateUser } from "../../../../stateManagement/reducers/usersReducer";
import { strengthColor, strengthIndicator } from "../../../../utils/password-strength";
import ConfigureAuthenticatorAppModal from "../modals/ConfigureAuthenticatorAppModal";

const EditSecurity = () => {

    const dispatch = useDispatch();
    const { user, authToken } = useSelector(state => state.auth);

    const {
        fetchingAuthenticatorSecret,
        authenticatorSecret,
        fetchAuthenticatorSecretErr,
    } = useSelector(state => state.authenticator);

    const {
        updatingUser,
        updatedUser,
        updateUserErrs
    } = useSelector(state => state.users);

    const [password, setPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [retypedNewPassword, setRetypedNewPassword] = useState("");

    const [usesEmail2FA, setUsesEmail2FA] = useState(null);
    const [usesAuthenticator2FA, setUsesAuthenticator2FA] = useState(null);

    const [showConfigureAuthenticatorModal, setShowConfigureAuthenticatorModal] = useState(false);

    const [level, setLevel] = useState();

    const changePassword = (value) => {
        const temp = strengthIndicator(value);
        setLevel(strengthColor(temp));
    };

    const [showPassword, setShowPassword] = useState(false);

    const [termsAgreed, setTermsAgreed] = useState(false);

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }

    const handleFieldChange = (field) => {
        dispatch(clearUpdateUserFieldErr(field));

        if (updateUserErrs.form) {
            dispatch(tryResetUpdateUserFormErr());
        }
    }

    const [isInitRender1, setIsInitRender1] = useState(true);
    useEffect(() => {
        if (isInitRender1) {
            setIsInitRender1(false);
            return;
        }

        if (updatedUser) {
            setPassword("");
            setNewPassword("");
            setRetypedNewPassword("");
        }
    }, [updatedUser]);

    const [show, setShow] = useState(false);

    useEffect(() => {
        setShow(true);
        return () => {
            setShow(false);
        }
    }, []);

    const CustomImg = styled("img")({
        height: "100%",
        maxHeight: "20rem"
    })

    return (
        <>
            <Slide direction="up" in={show} >
                <Box sx={{ height: "fit-content" }} >
                    <Stack sx={{
                        mt: 2,
                        mx: 3,
                    }} spacing={2} >
                        <Card
                            sx={{
                                position: "relative",
                                py: 2,
                                px: 2,
                            }}
                        >
                            <MDTypography variant="h5" fontWeight="medium">Update Your Password</MDTypography>
                            <Grid container spacing={2} mt={1} sx={{ mb: "3.5rem" }} alignItems="center" justifyContent="space-between" >
                                <Grid item xs={12} md={6}>
                                    <Grid container spacing={2} mt={1}>
                                        <Grid item xs={12}>
                                            <Stack
                                                spacing={1}
                                                alignItems="flex-start"
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="editPassowrd"
                                                    label="Current Password"
                                                    type="password"
                                                    value={password}
                                                    onChange={e => {
                                                        setPassword(e.target.value);
                                                        handleFieldChange("oldPassword");
                                                    }}
                                                    variant="outlined"
                                                    error={Boolean(updateUserErrs.oldPassword)}
                                                />
                                                {
                                                    updateUserErrs.oldPassword

                                                    &&

                                                    <FormHelperText error id="oldPassword-error">
                                                        {updateUserErrs.oldPassword}
                                                    </FormHelperText>
                                                }
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} mt={4}>
                                            <Stack
                                                spacing={1}
                                                alignItems="flex-start"
                                            >
                                                <FormControl sx={{ width: '100%' }} variant="outlined">
                                                    <InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
                                                    <OutlinedInput
                                                        id="outlined-adornment-password"
                                                        fullWidth
                                                        type={showPassword ? 'text' : 'password'}
                                                        endAdornment={
                                                            <InputAdornment position="end">
                                                                <IconButton
                                                                    aria-label="toggle password visibility"
                                                                    onClick={handleClickShowPassword}
                                                                    onMouseDown={handleMouseDownPassword}
                                                                    edge="end"
                                                                >
                                                                    {showPassword ? <Visibility color="secondary" /> : <VisibilityOff color="secondary" />}
                                                                </IconButton>
                                                            </InputAdornment>
                                                        }
                                                        label="New Password"
                                                        value={newPassword}
                                                        onChange={e => {
                                                            setNewPassword(e.target.value);
                                                            handleFieldChange("password");
                                                            changePassword(e.target.value);
                                                        }}
                                                        error={Boolean(updateUserErrs.password)}
                                                    />
                                                </FormControl>
                                                {
                                                    updateUserErrs.password

                                                    &&

                                                    <FormHelperText error id="oldPassword-error">
                                                        {updateUserErrs.password}
                                                    </FormHelperText>
                                                }
                                                {
                                                    (newPassword !== "")

                                                    &&

                                                    <FormControl fullWidth sx={{ mt: 2 }}>
                                                        <Grid container spacing={2} alignItems="center">
                                                            <Grid item>
                                                                <MDBox sx={{ bgcolor: level?.color, width: 85, height: 8, borderRadius: '.4375rem' }} />
                                                            </Grid>
                                                            <Grid item>
                                                                <MDTypography variant="subtitle1" fontSize="0.75rem">
                                                                    {level?.label}
                                                                </MDTypography>
                                                            </Grid>
                                                        </Grid>
                                                    </FormControl>
                                                }
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Stack
                                                spacing={1}
                                                alignItems="flex-start"
                                            >
                                                <TextField
                                                    fullWidth
                                                    id="retypedPassword"
                                                    label="Retype New Password"
                                                    type="password"
                                                    value={retypedNewPassword}
                                                    onChange={e => {
                                                        setRetypedNewPassword(e.target.value);
                                                    }}
                                                    variant="outlined"
                                                    error={newPassword !== retypedNewPassword}
                                                />
                                                {
                                                    (newPassword !== retypedNewPassword)

                                                    &&

                                                    <FormHelperText error id="retyped-password-err">
                                                        This must be the same as the new password.
                                                    </FormHelperText>
                                                }
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6} sx={{ display: { xs: "none", md: "flex" } }}>
                                    <CustomImg sx={{ mx: "auto" }} src="/images/secureLogin.png" />
                                </Grid>
                            </Grid>
                            <Stack
                                sx={{
                                    position: "absolute",
                                    bottom: "1rem",
                                    right: "1rem"
                                }}
                            >
                                <AnimateButton>
                                    <MDButton
                                        variant="gradient"
                                        color="success"
                                        fullWidth
                                        onClick={e => {
                                            e.preventDefault();

                                            if ((newPassword !== "") && (newPassword === retypedNewPassword)) {
                                                const data = new FormData();

                                                data.append("password", newPassword);
                                                data.append("oldPassword", password);

                                                dispatch(tryUpdateUser({
                                                    authToken: authToken ?? "",
                                                    userId: user._id,
                                                    data
                                                }));
                                            }
                                        }}
                                    >
                                        {
                                            (updatingUser && (newPassword !== ""))

                                            &&

                                            'Updating Password'

                                        }
                                        {
                                            !updatingUser

                                            &&

                                            'Update Password'
                                        }
                                    </MDButton>
                                </AnimateButton>
                            </Stack>
                        </Card>
                        <Card
                            sx={{
                                position: "relative",
                                py: 2,
                                px: 2,
                            }}
                        >
                            <MDTypography variant="h5" fontWeight="medium">2 Factor Authentication</MDTypography>
                            <Grid container spacing={8} mt={1} sx={{ mb: "3.5rem", mt: '-2.5rem !important' }} justifyContent="stretch" >
                                <Grid item xs={12} md={6}>
                                    <MDBox sx={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
                                        <MDBox
                                            sx={{
                                                maxWidth: 368,
                                                display: 'flex',
                                                textAlign: 'center',
                                                alignItems: 'center',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            <MDButton
                                                variant="gradient"
                                                color={user?.usesEmail2FA ? "success" : "error"}
                                                onClick={e => {
                                                    e.preventDefault();
                                                }}
                                                sx={{
                                                    py: "1rem",
                                                    px: "1rem"
                                                }}
                                            >
                                                {
                                                    user?.usesEmail2FA

                                                    &&

                                                    <LockOutlined color="white" sx={{ fontSize: '1.75rem', height: "2rem", width: "2rem" }} />
                                                }
                                                {
                                                    !user?.usesEmail2FA

                                                    &&

                                                    <LockOpen color="white" sx={{ fontSize: '1.75rem', height: "2rem", width: "2rem" }} />
                                                }
                                            </MDButton>
                                            {
                                                user?.usesEmail2FA

                                                &&

                                                <MDTypography sx={{ fontWeight: 600, marginTop: 2, marginBottom: 2 }}>
                                                    E-Mail 2-Factor Authentication Enabled.
                                                </MDTypography>
                                            }
                                            {
                                                !user?.usesEmail2FA

                                                &&

                                                <MDTypography sx={{ fontWeight: 600, marginTop: 2, marginBottom: 2 }}>
                                                    E-Mail 2-Factor Authentication Disabled.
                                                </MDTypography>
                                            }
                                            <MDTypography variant='body2' mb={2} sx={{mt: 'auto !important'}}>
                                                E-mail 2-factor authentication adds an additional layer of security to your account by requiring more than just
                                                a password to log in. An O.T.P is e-mailed to you to confirm you own the e-mail address you want to login with.
                                            </MDTypography>
                                            {
                                                user?.usesEmail2FA

                                                &&

                                                <MDButton
                                                    variant="gradient"
                                                    color="error"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setUsesEmail2FA(false);

                                                        const data = new FormData();

                                                        data.append("usesEmail2FA", "false");

                                                        dispatch(tryUpdateUser({
                                                            authToken: authToken ?? "",
                                                            userId: user?._id ?? "",
                                                            data
                                                        }));
                                                    }}
                                                >
                                                    {
                                                        (updatingUser && (!usesEmail2FA) && (usesEmail2FA !== null))

                                                        &&

                                                        'Disabling'
                                                    }
                                                    {
                                                        !updatingUser

                                                        &&

                                                        'Disable'
                                                    }
                                                </MDButton>
                                            }
                                            {
                                                !user?.usesEmail2FA

                                                &&

                                                <MDButton
                                                    variant="gradient"
                                                    color="success"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setUsesEmail2FA(true);

                                                        const data = new FormData();

                                                        data.append("usesEmail2FA", "true");

                                                        dispatch(tryUpdateUser({
                                                            authToken: authToken ?? "",
                                                            userId: user?._id ?? "",
                                                            data
                                                        }));

                                                    }}
                                                >
                                                    {
                                                        (updatingUser && usesEmail2FA)

                                                        &&

                                                        'Enabling'
                                                    }
                                                    {
                                                        !updatingUser

                                                        &&

                                                        'Enable'
                                                    }
                                                </MDButton>
                                            }
                                        </MDBox>
                                    </MDBox>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <MDBox sx={{ display: 'flex', justifyContent: 'center', height: '100%' }}>
                                        <MDBox
                                            sx={{
                                                maxWidth: 368,
                                                display: 'flex',
                                                textAlign: 'center',
                                                alignItems: 'center',
                                                flexDirection: 'column'
                                            }}
                                        >
                                            <MDButton
                                                variant="gradient"
                                                color={user?.usesAuthenticator2FA && user?.authenticatorSecret?.confirmedAt ? "success" : "error"}
                                                onClick={e => {
                                                    e.preventDefault();
                                                }}
                                                sx={{
                                                    py: "1rem",
                                                    px: "1rem"
                                                }}
                                            >
                                                {
                                                    user?.usesAuthenticator2FA

                                                    &&

                                                    <LockOutlined color="white" sx={{ fontSize: '1.75rem', height: "2rem", width: "2rem" }} />
                                                }
                                                {
                                                    !user?.usesAuthenticator2FA

                                                    &&

                                                    <LockOpen color="white" sx={{ fontSize: '1.75rem', height: "2rem", width: "2rem" }} />
                                                }
                                            </MDButton>
                                            {
                                                (user?.usesAuthenticator2FA && user?.authenticatorSecret?.confirmedAt)

                                                &&

                                                <MDTypography sx={{ fontWeight: 600, marginTop: 2, marginBottom: 2 }}>
                                                    Authenticator App 2-Factor Authentication Enabled.
                                                </MDTypography>
                                            }
                                            {
                                                (!user?.usesAuthenticator2FA && user?.authenticatorSecret?.confirmedAt)

                                                &&

                                                <MDTypography sx={{ fontWeight: 600, marginTop: 2, marginBottom: 2 }}>
                                                    Authenticator App 2-Factor Authentication Disabled.
                                                </MDTypography>
                                            }
                                            {
                                                (!user?.authenticatorSecret?.confirmedAt)

                                                &&

                                                <MDTypography sx={{ fontWeight: 600, marginTop: 2, marginBottom: 2 }}>
                                                    Authenticator App 2-Factor Authentication Unconfigured.
                                                </MDTypography>
                                            }
                                            <MDTypography variant='body2' mb={2} sx={{mt: 'auto !important'}}>
                                                Authenticator App 2-factor authentication adds an additional layer of security to your account by requiring more than just
                                                a password to log in. You will be required to check your Authenticator App for your O.T.P.
                                            </MDTypography>
                                            {
                                                (user?.usesAuthenticator2FA && user?.authenticatorSecret?.confirmedAt)

                                                &&

                                                <MDButton
                                                    variant="gradient"
                                                    color="error"
                                                    onClick={e => {
                                                        e.preventDefault();

                                                        setUsesAuthenticator2FA(false);

                                                        const data = new FormData();

                                                        data.append("usesAuthenticator2FA", "false");
                                                        dispatch(tryUpdateUser({
                                                            authToken: authToken ?? "",
                                                            userId: user?._id ?? "",
                                                            data
                                                        }));

                                                    }}
                                                >
                                                    {
                                                        (updatingUser && (usesAuthenticator2FA === false))

                                                        &&

                                                        'Disabling'
                                                    }
                                                    {
                                                        (!updatingUser)

                                                        &&

                                                        'Disable'
                                                    }
                                                </MDButton>
                                            }
                                            {
                                                (!user?.usesAuthenticator2FA && user?.authenticatorSecret?.confirmedAt)

                                                &&

                                                <MDButton
                                                    variant="gradient"
                                                    color="success"
                                                    onClick={e => {
                                                        e.preventDefault();

                                                        setUsesAuthenticator2FA(true);

                                                        const data = new FormData();

                                                        data.append("usesAuthenticator2FA", "true");
                                                        dispatch(tryUpdateUser({
                                                            authToken: authToken ?? "",
                                                            userId: user?._id ?? "",
                                                            data
                                                        }));
                                                    }}
                                                >
                                                    {

                                                        (updatingUser && usesAuthenticator2FA)

                                                        &&

                                                        'Enabling'
                                                    }
                                                    {
                                                        (!updatingUser)

                                                        &&

                                                        'Enable'
                                                    }
                                                </MDButton>
                                            }
                                            {
                                                (!user?.authenticatorSecret?.confirmedAt)

                                                &&

                                                <MDButton
                                                    variant="gradient"
                                                    color="success"
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        setShowConfigureAuthenticatorModal(true);
                                                    }}
                                                >
                                                    {
                                                        showConfigureAuthenticatorModal

                                                        &&

                                                        'Configuring...'
                                                    }
                                                    {
                                                        !showConfigureAuthenticatorModal

                                                        &&

                                                        'Configure'
                                                    }
                                                </MDButton>
                                            }
                                        </MDBox>
                                    </MDBox>
                                </Grid>
                            </Grid>
                        </Card>
                    </Stack>
                </Box>
            </Slide>
            <ConfigureAuthenticatorAppModal show={showConfigureAuthenticatorModal} setShow={setShowConfigureAuthenticatorModal} />
        </>
    );
}

export default EditSecurity;